import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import ITab from "interfaces/Tab";

export enum EPreRacesTableTab {
  ENTRIES = "Entries",
  ENTRY_EXAMS = "Entry Exams",
  ENTRY_RESULTS = "Results",
  RACE_DAY = "Race Day",
  RACE_DAY_RESULTS = "Race Day Results"
}

export enum EPreRaceTableSortingField {
  HORSE_NAME = "horse.name",
  TRAINER_LAST_NAME = "horse.trainer.lastName",
  RACE_DATE = "raceDate",
  RACE_NUMBER = "raceNumber",
  RACE_POSITION = "racePosition",
  IS_FLAGGED = "isFlagged",
  FLAG_PRIORITY = "flag.priority",
  RISK_LEVEL = "horse.healthWatchStatus",
  HIGH_SPEED_FURLONGS = "highSpeedFurlongs",
  BARN_NAME = "horse.barn.name",
  STALL_NUMBER = "horse.stallNumber",
  LAST_WORKOUT_DATE = "horse.lastWorkoutDate",
  LAST_RACE_DATE = "horse.lastRaceDate",
  LAST_EXAM_DATE = "horse.lastExamDate",
  TOTAL_VET_LISTS_COUNT = "horse.totalVetListsCount",
  ACTIVE_VET_LISTS_COUNT = "horse.activeVetListsCount",
  RISK_FACTORS_COUNT = "horse.riskFactorsCount",
  RISK_FACTOR_SHORT_DESCRIPTIONS = "horse.riskFactorShortDescriptions",
  RISK_FACTOR_SCORE = "horse.riskFactorScore"
}

export const columnSortingOptions = new Map<
  EPreRaceTableSortingField,
  EPreRaceTableSortingField[]
>([
  [
    EPreRaceTableSortingField.HORSE_NAME,
    [EPreRaceTableSortingField.HORSE_NAME]
  ],
  [
    EPreRaceTableSortingField.TRAINER_LAST_NAME,
    [EPreRaceTableSortingField.TRAINER_LAST_NAME]
  ],
  [EPreRaceTableSortingField.RACE_DATE, [EPreRaceTableSortingField.RACE_DATE]],
  [
    EPreRaceTableSortingField.RACE_NUMBER,
    [EPreRaceTableSortingField.RACE_NUMBER]
  ],
  [
    EPreRaceTableSortingField.RACE_POSITION,
    [EPreRaceTableSortingField.RACE_POSITION]
  ],
  [
    EPreRaceTableSortingField.IS_FLAGGED,
    [EPreRaceTableSortingField.IS_FLAGGED]
  ],
  [
    EPreRaceTableSortingField.FLAG_PRIORITY,
    [EPreRaceTableSortingField.FLAG_PRIORITY]
  ],
  [
    EPreRaceTableSortingField.RISK_LEVEL,
    [EPreRaceTableSortingField.RISK_LEVEL]
  ],
  [
    EPreRaceTableSortingField.HIGH_SPEED_FURLONGS,
    [EPreRaceTableSortingField.HIGH_SPEED_FURLONGS]
  ],
  [EPreRaceTableSortingField.BARN_NAME, [EPreRaceTableSortingField.BARN_NAME]],
  [
    EPreRaceTableSortingField.STALL_NUMBER,
    [EPreRaceTableSortingField.STALL_NUMBER]
  ],
  [
    EPreRaceTableSortingField.LAST_WORKOUT_DATE,
    [EPreRaceTableSortingField.LAST_WORKOUT_DATE]
  ],
  [
    EPreRaceTableSortingField.LAST_RACE_DATE,
    [EPreRaceTableSortingField.LAST_RACE_DATE]
  ],
  [
    EPreRaceTableSortingField.LAST_EXAM_DATE,
    [EPreRaceTableSortingField.LAST_EXAM_DATE]
  ],
  [
    EPreRaceTableSortingField.ACTIVE_VET_LISTS_COUNT,
    [
      EPreRaceTableSortingField.ACTIVE_VET_LISTS_COUNT,
      EPreRaceTableSortingField.TOTAL_VET_LISTS_COUNT
    ]
  ],
  [
    EPreRaceTableSortingField.RISK_FACTORS_COUNT,
    [
      EPreRaceTableSortingField.RISK_FACTORS_COUNT,
      EPreRaceTableSortingField.RISK_FACTOR_SHORT_DESCRIPTIONS
    ]
  ],
  [
    EPreRaceTableSortingField.RISK_FACTOR_SCORE,
    [EPreRaceTableSortingField.RISK_FACTOR_SCORE]
  ]
]);

export interface IPreRaceTableTab extends ITab<EPreRacesTableTab> {
  entryStatuses: racehorse360.UpcomingRaceEntryStatus[];
  itemsPerPage: number;
  additionalRequestedFields?: string[];
  forceOrderBy?: EPreRaceTableSortingField;
}
